import { ActionBase } from '../../../core/store/action/ActionBase';
import { UserAccountDetailedStatusModel } from '../../models/UserAccountDetailedStatusModel';

export const GET_USER_CURRENT_STATUS_SUCCESS = '[Customer] Get User Current Status Success';

export class GetUserCurrentStatusSuccessAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = GET_USER_CURRENT_STATUS_SUCCESS;

  constructor(public payload: { userKey: string, userCurrentStatus: UserAccountDetailedStatusModel }) {}
}



// WEBPACK FOOTER //
// ./src/app/customer/store/actions/GetUserCurrentStatusSuccessAction.ts